import React from 'react';
import { Link } from 'react-router-dom';
import Socials from './Socials';

const Footer = () => {
    return (
        <div className='w-full text-700 pb-4'>
            <div className='flex flex-column m-auto w-full p-3 md:w-9 font-sans'>
                <div className='w-full text-400 mt-3 mb-2 pt-3' style={{borderTop: '1px solid'}} >
                </div>
                <div className='flex gap-3 flex-column lg:flex-row w-full mb-6'>
                    <div className='w-full text-800' >
                        <div className='text-600'>
                            Website by <Link to={'https://growspective.com'} target="_blank" rel="noopener noreferrer"  className='' style={{cursor: 'pointer', textDecoration: 'underline', color: 'inherit'}}>Growspective Consulting</Link><br />
                        </div>
                        <div className='pt-3 text-800'>
                            Copyright © 2024-2026 - Panasea - Email: info@panasea-band.com - <a href="https://panasea-band.com/impressum" target="_blank" rel="noopener noreferrer" className='text-gray-600'>Impressum</a><br />
                            All rights reserved
                        </div>
                    </div>
                    <div className='lg:justify-content-end justify-content-center flex'>
                        <Socials />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;